/** Splits prose into a lead sentence and the remainder for an editorial opening. */
export const splitLead = (text: string) => {
  const latin = text.match(/^(.{40,280}?[.!?])\s+(.*)$/s);
  if (latin) return { lead: latin[1], rest: latin[2] };
  // Chinese full-width punctuation needs no following space
  const cjk = text.match(/^(.{10,140}?[。！？])(.+)$/s);
  if (cjk) return { lead: cjk[1], rest: cjk[2].trim() };
  return { lead: text, rest: "" };
};

/** Pulls a trailing "Image: …" credit off a description so it can be shown as a caption. */
export const splitImageNote = (text: string) => {
  const idx = text.search(/\s+Image:\s|\s*(图片|Immagine)[:：]\s*/);
  if (idx === -1) return { body: text, note: "" };
  return { body: text.slice(0, idx).trim(), note: text.slice(idx).trim() };
};
